//@flow
import Constants from '../constants';
import Dispatcher from '../dispatcher';

export default {
  openCreateAccountModal() {
    Dispatcher.dispatchAction(Constants.OPEN_CREATE_ACCOUNT_MODAL);
  },

  closeCreateAccountModal() {
    Dispatcher.dispatchAction(Constants.CLOSE_CREATE_ACCOUNT_MODAL);
  },

  expandCreateAccountModal() {
    Dispatcher.dispatchAction(Constants.EXPAND_CREATE_ACCOUNT_MODAL);
  },

  collapseCreateAccountModal() {
    Dispatcher.dispatchAction(Constants.COLLAPSE_CREATE_ACCOUNT_MODAL);
  },
};
